import {OrderIntervalModel} from './order-interval.model';
import {Unit, UnitImagesShort} from './unit';
import {EndUserPricePlanModel} from '../../unit-card/end-user-price-plan-card/end-user-price-plan.model';
import {EndUserModel} from '../../end-user/models/end-user.model';
import {
  PenaltyExtendedInformationModel,
  TripDebtExtendedInformationModel
} from '../../end-user-order/end-user-order-list/end-user-order-view/end-user-order-debt-log/end-user-order-penalty-debt.model';
import {FinancialOperationModel} from '../../financial-operation/financial-operation-list/financial-operation.model';
import {SubscriptionModel} from '../../subscription/subscription-list/subscription.model';

export type OrderStatus = 'booked' | 'active' | 'paused' | 'finished' | 'cancelled' | 'booking_timeout';

export class OrderModel {
  id: number;
  status: OrderStatus;
  unit_id: number;
  start_time: number;
  finish_time: number;

  endUserOrderIntervals: OrderIntervalModel[] = [];
  endUserPricePlan: EndUserPricePlanModel;

  end_user_full_name: string;

  demand_coefficient: number;

  end_user_id: number;
  end_user_price_plan_id: number;
  endUserPricePlanTranslatedName: string;
  region_name: string;
  project_custom_name: string;

  mileage: number;
  current_mileage: number;
  readonly end_user_price_plan_name: string;
  readonly end_user_login: string;
  readonly total_price: number;


  charge_at_finish: number;
  charge_at_finish_status: string;
  charge_at_start: number;
  charge_at_start_status: string;
  tripDebt: number;
  penaltyDebt: number;
  unit_model_name: string;
  unit_name: string;
  currency_code: string;
  unitImagesShort: Array<UnitImagesShort>;

  unit: Unit;
  end_user_position: Array<number>;
  start_unit_position: [number, number];
  finish_unit_position: [number, number];
  start_unit_position_address: string;
  finish_unit_position_address: string;
  start_request_os_type: string;
  start_request_os_version: string;
  start_request_device_vendor: string;
  start_request_device_model: string;
  start_request_user_agent: string;
  start_request_client_name: string;
  start_request_client_version: string;
  cashback_amount: string;
  orderBonus: number;
  how_order_was_paid: {
    balance: string;
    bank_card: string;
    bank_type: string;
    subscription: {id: number, name: string}
  };
  insurancePolicyId: string;
  insurancePolicyType: string;
  insurancePolicy: string;
  insuranceCompanyId: number;
  calculated_insurance_status_id: number;
  endUser: EndUserModel;
  paymentMethods: Array<any>;
  debt: number;
  tripDebtExtendedInformation: TripDebtExtendedInformationModel;
  penaltyExtendedInformation: Array<PenaltyExtendedInformationModel>;
  'finish_by': string;
  'finish_by_user_login': string;
  'finish_by_user_name': string;
  'finish_by_user_id': number;
  'finish_by_source': 'admin' | 'client' | 'server' | 'notification';
  finish_by_end_user_notification_id: number;
  finish_by_user_role: number;
  unit_type_name: string;
  end_user_price_plan_currency_code: string;
  reason_for_cancellation: string;
  comment_to_finish_or_cancel: string;
  lastFinancialOperation: FinancialOperationModel;
  in_finish_allow_area: boolean;
  subscription: SubscriptionModel;
  startRegion: {
    name: string;
    projectCountry: { country: { name: string; } }
  };
  rating: number;
  review: string;
  track: string;

  static statusText(status: 'booked' | 'active' | 'paused' | 'finished' | 'cancelled' | 'booking_timeout') {
    switch (status) {
      case 'booked':
        return 'Booked';
      case 'active':
        return 'Active';
      case 'paused':
        return 'Pause';
      case 'finished':
        return 'Finished';
      case 'cancelled':
        return 'Canceled';
      case 'booking_timeout':
        return 'Booking timeout';
    }
  }
}
